import { FiInfo, FiAlertTriangle, FiAlertOctagon, PiCheckCircleFill } from '@/components/react-icons/main';

const statusIconMap = {
  info: FiInfo,
  warn: FiAlertTriangle,
  error: FiAlertOctagon,
  success: PiCheckCircleFill
};

export default (status) => statusIconMap[status] || FiInfo;
